import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewText from './ReviewText';
import { IReviewNew } from '../../shared/interfaces/IReviewNew';
import { Person } from '@mui/icons-material';

interface Props {
  reviewEntry: IReviewNew;
}

const DataShakeSummary: FC<Props> = ({ reviewEntry }) => {
  const theme = useTheme();

  const { text, reviewTitle, reviewText, header, username, reviewerTitle, name } =
    reviewEntry.review;

  const uname = username || reviewerTitle || name;

  return (
    <>
      {uname && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {uname}
          </Typography>
        </Box>
      )}
      {(header || reviewTitle) && (
        <Typography
          variant="h6"
          sx={{ mt: theme.spacing(2) }}
        >
          {header || reviewTitle}
        </Typography>
      )}
      {(text || reviewText) && <ReviewText text={text || reviewText} />}
    </>
  );
};

export default DataShakeSummary;
